import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class DropdownService {
  private openDropdownSubject = new BehaviorSubject<string | null>(null);
  openDropdown$ = this.openDropdownSubject.asObservable();

  setOpenDropdown(dropdownId: string | null) {
    this.openDropdownSubject.next(dropdownId);
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/dropdown.service.ts